// extracted by mini-css-extract-plugin
export var imageFive = "slider-module--imageFive--OkvVC";
export var imageFour = "slider-module--imageFour--UW6QU";
export var imageOne = "slider-module--imageOne--m-6ja";
export var imageThree = "slider-module--imageThree--EUNRU";
export var imageTwo = "slider-module--imageTwo--zFbMh";
export var sliderHeight = "slider-module--sliderHeight--j-Ya2";
export var sliderText = "slider-module--sliderText--vivdI";
export var sliderTextFont = "slider-module--sliderTextFont--xcnas";
export var sliderWidth = "slider-module--sliderWidth--h9+sq";